module.exports = __webpack_public_path__ + "img/2.b447f925.jpg";